import { Tag } from '../interface';

export const tapTag = new Tag('no', 'msapplication-tap-highlight');
